// extracted by mini-css-extract-plugin
export default {"button-change":"SignUpForm_button-change__id3sI"};